export const IntroText = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 space-y-4">
    <p className="text-base sm:text-lg leading-relaxed text-slate-700 max-w-4xl">
      Use this tool to compare the costs of using your own permanent or contracted labour for duct installation against the hourly cost of ARLO&apos;s Managed Installation Service. (We&apos;ve set the default figure for our service at an average value - but get in touch for an accurate quote for your project).
    </p>
    <ol className="list-decimal pl-6 space-y-2 text-base sm:text-lg leading-relaxed text-slate-700 max-w-4xl">
      <li>Simply use the sliders to set all the additional costs and the tool will show the comparison.</li>
      <li>Once you&apos;ve done that, set your project risk appetite for handling installation yourselves.</li>
    </ol>
    <p className="text-base sm:text-lg leading-relaxed text-slate-700 max-w-4xl">
      The soft costs around project risk include productivity levels, labour availability, coordinating logistics, quality, defects, install efficiency, rework etc. You should also consider time, stress, pressure and opportunity costs when setting a risk level.
    </p>
  </div>
);
